// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flex[data-v-2673585a] {\n  display: flex;\n  margin-bottom: 10px;\n}", ""]);
// Exports
module.exports = exports;
